<script setup lang="ts"></script>

<template>
    <div
        class="bg-cover bg-top drop-shadow-xl sm:drop-shadow-lg"
        style="background-image: url(/images/careers/ABCCareersHeader.svg)"
    >
        <div class="px-10 py-20 text-gray-800">
            <H1Heading size="text-3xl lg:text-5xl" class="text-abc-blue-lighter mb-6 text-center">
                Careers at
                <span class="md:block">American Book Company</span>
            </H1Heading>
            <p class="mx-auto text-center sm:w-3/4 md:w-3/5 lg:w-2/5">
                At American Book Company we believe our people are the secret to creating great classroom solutions and
                helping students across the United States achieve success.
            </p>

            <div class="mt-10 text-center">
                <ButtonPrimary type="link" href="#career-list">View Open Positions</ButtonPrimary>
            </div>
        </div>
    </div>
</template>

<style scoped></style>
